module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABPElEQVQYGQXBMUuUcRwA4Of3+hfO4/I8IRC6avPWApemWsIaAseGaGxuqq0P0FgfoAiilr5CQeQSRLQJIiJeeZavnZ6+9cr1/nueyH3XtB34Yj8yAACQXHVDT9e65yYAAEDkro62e6547AcAgKyKfymOHOXChjUPHJoBAGHqa/6UQHZs0YqhAABZ111PEwgtjQ9eOAMADLy0kiCavKvR8StOAYDc90dZAEqNvhYAkMMShgVgqjSRAQAzehrfC0Bty18NACB0VEYJUBu56HJuA4A5F/x0mgCVb657YqKQBKYasxasOwyA3HXLHS27xgjnXJK9985BAlBbsGxW6ZnSvIcGzmyqIycA59321rZHerGd5w28suG+RccJQGXHTfvGfqO2Z9WyPRUFgLE3hnhthBMfleZ8dgIAAAAA+A/aTG0fNlLR3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/lsNavIcon/cgIcon.png
// module id = B6hS
// module chunks = 95